<template>
  <div class="select-device-box">
    <div class="content-box">
      <!-- :slots="taskStrategy==='2'?['taskDesc','firmwareVersion']:['taskDesc']" -->
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary" @click="addDevice">
              <i class="icon icon-add"></i>
              {{ $t('dms_firmwareTask_select_device.tian_jia_she_bei') }}
            </el-button>
            <!--  添加Modem 只有bt modem才能添加modem-->
            <!--
              2022-7-29 查工说先要开放
              v-if="`${data.serviceType}` !== '3' || (`${data.serviceType}` === '3' && resourceType === 'modem') || (`${data.serviceType}` === '3' && resourceType === 'bt')" -->
            <el-button
              type="primary"
              @click="addModem"
            >
              <i class="icon icon-add"></i>
              {{ $t('dms_firmwareTask_select_device.tian_jiaModem') }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delDevices" :disabled="!tableSelect.length">
              <i class="icon icon-shanchu"></i>
              {{ $t('Common.com_remove') }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delDevicesAll" >
              <i class="icon icon-shanchu"></i>
              {{ $t('dms_firmwareTask_select_device.yi_chu_quan_bu') }}
            </el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <el-dropdown trigger="click" :hide-on-click="false" @visible-change="saveTableColumn">
              <el-button class="table-set" icon="icon icon-tableset"></el-button>
              <el-dropdown-menu slot="dropdown" class="custom-dropdown">
                <el-dropdown-item>
                  <el-checkbox v-model="isAllColumn" @change="setAllColumn">
                    {{ $t('Common.com_sel_all') }}
                  </el-checkbox>
                </el-dropdown-item>
                <el-dropdown-item v-for="(item, i) in tableColumn" :key="i">
                  <el-checkbox v-model="item.selected" @change="formatTable">
                    {{ item.columnName }}
                  </el-checkbox>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_firmwareTask_select_device.jshModemSNcpSN')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
          <!-- <el-form-item style="float: right;">
            <div class="info">
              {{ $t('page_task_gong') }}<span class="default">{{totalRows}}</span>{{ $t('page_task_tiao_shu_ju') }}，{{ $t('page_task_yztg') }}<span class="default">{{checkSuccessNum}}</span>{{ $t('page_task_tiao') }}，{{ $t('page_task_wei_tong_guo') }}<span class="caveat">{{checkFailureNum}}</span>条
            </div>
          </el-form-item>-->
        </el-form>
      </div>
      <switch-container ref="container" @search="onSearch" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_firmwareTask_select_device.zhlxsj')">
            <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_select_device.chan_pin_xing_hao')">
            <custom-select
              url="productCodeSelectList"
              v-model="formSearch.productCode"
              :listener="formSearch.websiteCode"
              :params="{ websiteCode: formSearch.websiteCode }"
              :props="{ label: 'productCode', value: 'productCode' }"
              width="100%"
            ></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_select_device.shou_hou_gong_si')">
            <el-input v-model="formSearch.afterServiceName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_select_device.dai_li_gong_si')">
            <el-input v-model="formSearch.agentCoName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_select_device.zu_lin_fang')">
            <el-input v-model="formSearch.customerName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_select_device.xiang_mu')">
            <el-input v-model="formSearch.locationName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_select_device.xygjbb')">
            <el-input v-model="formSearch.fwVersion"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_select_device.ji_qi_ban_ben')">
            <el-input v-model="formSearch.machineVersion"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          :data="deviceList"
          ref="customTb1"
          v-model="tableSelect"
          type="checkbox"
          height="100%"
          :loading="isLoading"
          :index="true"
          :column="tableColumn"
          :slots="['taskDesc', 'isMatchFwVersion', 'action']"
          @filter="filterChange"
          @sort="sortChange"
        >
          <template v-slot:isMatchFwVersion="scope">
            <div :class="scope.row.isMatchFwVersion === 1 ? 'green' : 'red'">
              {{ getDicValue('isynergy_cloud_approval_result', scope.row.isMatchFwVersion) }}
            </div>
          </template>
          <template v-slot:taskDesc="scope">
            <el-popover placement="bottom" width="200" trigger="hover" v-if="scope.row.taskDesc">
              {{ scope.row.taskDesc }}
              <i class="icon icon-banbenxinxi" slot="reference" style="color: #2aafff; font-size: 16px"></i>
            </el-popover>
          </template>
          <template v-slot:action="scope">
            <el-button @click="deleteDevice(scope.row)" type="text" size="mini">{{ $t('Common.com_remove') }}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="previous">
        {{ $t('dms_firmwareTask_select_device.syblrzl') }}
      </el-button>
      <el-button @click="saveTask">
        {{ $t('dms_firmwareTask_select_device.bao_cun_ren_wu') }}
      </el-button>
      <el-button type="primary" @click="releaseTask">
        {{ $t('dms_firmwareTask_select_device.bcbfbrw') }}
      </el-button>
    </div>

    <firmware-addDevice-dialog v-if="dialogVisible" :data="dialogData" :model="dialogModel" @close="dialogVisible = false" @success="getSteps3"></firmware-addDevice-dialog>
    <firmware-addModem-dialog v-if="dialogVisible1" :data="dialogData1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getSteps3"></firmware-addModem-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import firmwareAddDeviceDialog from './firmwareTask_addDevice_dialog';
import firmwareAddModemDialog from './firmwareTask_addModem_dialog';

export default {
  mixins: [resetFormSearchMixins],
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    data: [String, Object, Array],
    taskId: [String, Number],
    firmwareId: [String, Number],
  },
  components: {
    firmwareAddDeviceDialog,
    firmwareAddModemDialog,
  },
  data() {
    return {
      tableCode: 'select_device',
      // 分页
      formSearch: {
        search: '',
        taskName: '',
        pageSize: 50,
        pageNum: 1,
        taskId: '',
        isAssociate: 1, // 是否关联 0不关联 1关联

        // 高级搜索
        //  售后公司
        afterServiceName: '',
        // 代理公司
        agentCoName: '',
        // 租赁方
        customerName: '',
        timer: [],
        lastOnlineStartTime: '',
        lastOnlineEndTime: '',
        productCode: '',
        locationName: '',
        fwVersion: '',
        machineVersion: '',
      },
      totalRows: null,
      deviceList: [],
      versionListSelect: [],
      tableColumnVersion: null,
      checkSuccessNum: 0,
      checkFailureNum: 0,

      taskStrategy: '',
      controlMode: '',
      resourceType: '',
      // 新增设备
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},
      // 添加Modem
      dialogVisible1: false,
      dialogData1: {},
      dialogModel1: {},
    };
  },
  mounted() {
    this.isLoading = true;
    this.getSteps3();
    this.getTaskInfo();
    this.controlMode = this.data.controlMode;
  },
  methods: {
    onCancel() {
      this.$router.back();
    },
    addDevice: function () {
      this.dialogVisible = true;
      this.dialogData.taskId = this.taskId;
      this.dialogData.firmwareId = this.firmwareId;
      this.dialogData.taskStrategy = this.taskStrategy;
      this.dialogData.controlMode = this.controlMode;
      this.dialogData.serviceType = this.data.serviceType;
      this.dialogModel.title = this.$t('dms_firmwareTask_select_device.tian_jia_she_bei');
      this.dialogModel.type = 'add';
    },
    addModem: function () {
      this.dialogVisible1 = true;
      this.dialogData1.taskId = this.taskId;
      this.dialogData1.firmwareId = this.firmwareId;
      this.dialogData1.taskStrategy = this.taskStrategy;
      this.dialogData1.controlMode = this.controlMode;
      this.dialogData1.serviceType = this.data.serviceType;
      this.dialogModel1.title = this.$t('dms_firmwareTask_select_device.tian_jiaModem');
      this.dialogModel1.type = 'add';
    },
    delDevices: function () {
      const tips = this.$t('dms_firmwareTask_select_device.nqdyycxzdsbm');
      const taskDetailIds = this.tableSelect.map(item => item.taskDetailId);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.commandTaskBatchDetailDelete, {
            taskDetailIds,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    delDevicesAll: function () {
      const tips = this.$t('dms_firmwareTask_select_device.nqdyycqbsbm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.commandTaskDetailDeleteAll}/${this.taskId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
    // 获取任务详情
    getTaskInfo() {
      this.$getJSON(`${apis.commandTaskDevice}/${this.taskId}`).then((res) => {
        this.taskStrategy = `${res.data.taskStrategy}`;
        this.resourceType = res.data.resourceType;
        if (this.taskStrategy === '2') {
          // 延期不要现有固件版本号
          this.getTableColumn(['firmwareVersion']);
        } else {
          this.getTableColumn();
        }
      });
    },
    getSteps3: function () {
      // 获取表格列
      // this.getTableColumnByName('firmware_version', 'tableColumnVersion');
      this.formSearch.taskId = this.taskId;
      // this.formSearch.taskId = '453245224021905408';
      this.formSearch.lastOnlineStartTime = this.formSearch.timer ? this.formSearch.timer[0] : '';
      this.formSearch.lastOnlineEndTime = this.formSearch.timer ? this.formSearch.timer[1] : '';
      // 第二步选择合同
      this.$getJSON(apis.commandTaskDevicePage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.deviceList = res.data.list || [];
        this.totalRows = res.data.total;
        this.checkSuccessNum = res.data.checkSuccessNum;
        this.checkFailureNum = res.data.checkFailureNum;
      });
    },
    previous: function () {
      this.$emit('previous');
    },
    onSearch() {
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getSteps3();
    },
    deleteDevice: function (row) {
      const tips = this.$t('dms_firmwareTask_select_device.nqdyycxzdsbm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.commandTaskDetailDelete}/${row.taskDetailId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },

    // 保存
    saveTask: function () {
      if (!this.deviceList.length) {
        this.$message.error(this.$t('dms_firmwareTask_select_device.qtjsb'));
        return;
      }
      if (this.controlMode === 1 && this.deviceList.length !== 1) {
        this.$message.error(this.$t('dms_firmwareTask_select_device.gldtopicCodeznxzygsb'));
        return;
      }
      if (this.deviceList.some(item => item.isMatchFwVersion === 0)) {
        this.$message.error(this.$t('dms_firmwareTask_select_device.qxscyzbtgdsj'));
        return;
      }
      this.jump('/iot/firmwareTask', { refresh: true }, true);
    },
    // 保存并发布
    releaseTask: function () {
      if (!this.deviceList.length) {
        this.$message.error(this.$t('dms_firmwareTask_select_device.qtjsb'));
        return;
      }
      if (this.controlMode === 1 && this.deviceList.length !== 1) {
        this.$message.error(this.$t('dms_firmwareTask_select_device.gldtopicCodeznxzygsb'));
        return;
      }
      if (this.deviceList.some(item => item.isMatchFwVersion === 0)) {
        this.$message.error(this.$t('dms_firmwareTask_select_device.qxscyzbtgdsj'));
        return;
      }
      const tips = this.$t('dms_firmwareTask_select_device.nqdyfbxzdrw');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.commandTaskPublish}`, {
            isPublish: 1,
            taskId: this.taskId,
          }).then(() => {
            this.clearTagByKeep('firmwareTask_item');
            this.jump('/iot/firmwareTask', {}, true);
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.select-device-box {
  display: flex;
  height: 100%;
  background-color: #ffffff;
  flex-direction: column;
  padding: 0 24px;
  box-sizing: border-box;

  .green {
    color: #67c23a;
  }

  .red {
    color: #f56c6c;
  }

  .content-box {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .btn-group {
    border-top: 1px solid #eef2f8;
    padding: 16px 0 16px 24px;
    height: 60px;
    z-index: 1;
    -webkit-box-flex: 0;
    flex: 0 0 60px;
  }
  .info {
    color: #6c757d;
    .default {
      color: $main-color;
    }
    .caveat {
      color: #ff5c5b;
    }
  }
}
</style>
